var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 18.93a8.928 8.928 0 1 0 0-17.858 8.928 8.928 0 0 0 0 17.857"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#286795",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 10.057a2.738 2.738 0 1 0 0-5.475 2.738 2.738 0 0 0 0 5.475M15.292 17.193A8.9 8.9 0 0 1 10 18.929c-1.981 0-3.811-.645-5.292-1.736a5.475 5.475 0 0 1 10.584 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user_circle.2ac635a44da9a19825de4e42b9cc19f0.svg";
export { ForwardRef as ReactComponent };